import { PERMISSION_OBJ_ROLE, PERMISSION_READ } from '@/constants/permissions';

import { Admin } from './components';

export const states = [
  {
    name: 'base-layout.admin',
    url: '/admin',
    component: Admin,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_ROLE, PERMISSION_READ]],
    },
  },
];
